export const NotificationString = {
  alert: { iconClass: "faInfoCircle", className: "notification-alert", title: "提醒" },
  system: { iconClass: "faExclamationCircle", className: "notification-info", title: "系統公告" },
  ads: { iconClass: "faPalette", className: "notification-ads", title: "最新消息" },
};
